/*
 * vaporizer-prescription (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { vaporizerPrescriptions } from "./vaporizer-prescription.schema"

/* Select */
export type VaporizerPrescription = z.infer<typeof selectVaporizerPrescriptionSchema>
export const selectVaporizerPrescriptionSchema = createSelectSchema(vaporizerPrescriptions)

/* Filters */
export type VaporizerPrescriptionFilters = z.infer<typeof vaporizerPrescriptionFiltersSchema>
export const vaporizerPrescriptionFiltersSchema = z.object({
	id:             z.string().optional(),
	patientId:      z.string().optional(),
	practitionerId: z.string().optional(),
	active:         z.boolean().optional(),
})

/* Create */
export const createVaporizerPrescriptionSchema = createInsertSchema(vaporizerPrescriptions)
	.partial(globalCreateExclude)
export type CreateVaporizerPrescription = z.infer<typeof createVaporizerPrescriptionSchema>

/* Update */
export const updateVaporizerPrescriptionSchema = createInsertSchema(vaporizerPrescriptions)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateVaporizerPrescription = z.infer<typeof updateVaporizerPrescriptionSchema>
